<template>
    <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" :aria-label="$t('altsImgs.slide1')"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" :aria-label="$t('altsImgs.slide2')"></button>
        </div>
        <div class="carousel-inner">
            <div class="carousel-item active">
            <img :src="`/images/slide/${$t('img.img1')}`" class="d-block w-100" :alt="$t('altsImgs.slide1')">
            </div>
            <div class="carousel-item">
            <img :src="`/images/slide/${$t('img.img2')}`" class="d-block w-100" :alt="$t('altsImgs.slide2')">
            </div>
        </div>
        <button class="carousel-control-prev d-none d-md-block" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ $t('carousel.previous') }}</span>
        </button>
        <button class="carousel-control-next d-none d-md-block" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ $t('carousel.next') }}</span>
        </button>
    </div>
</template>
<script>
export default {
  name: 'BannerHomeComponent'
}
</script>
